module.exports = __webpack_public_path__ + "static/media/11.104.384cbf79.webp";